<template>
  <div style="padding: 10px">
    <x-table
      ref="list"
      listApi="biz.warehouse.purchase.info.list"
      paginationLayout="total, sizes, prev, next, jumper"
      actionFixed="right"
      emptyLabel="暂无采购单记录信息"
      :fieldList="fieldList"
      :actionList="actionList"
      :paramList="paramList"
      :defaultParams="defaultParams"
      :actionWidth="150"
    >
      <template slot="param-extra" slot-scope="scope">
        <el-form :inline="true" :model="formInline" @submit.native.prevent>
          <el-form-item label="门店仓库">
            <customer-store-select
              v-if="!hiddenStore"
              v-model="storeGuid"
              :storehouseGuid="defaultParams.storehouseGuid"
              :multiple="false"
              :clearable="true"
            />
          </el-form-item>
          <el-form-item label="商品类型">
            <el-select
              v-model="formInline.paymentAccount"
              @change="queryClick"
              style="width: 120px"
              placeholder="支付方式"
            >
              <el-option label="全部" value=""> </el-option>
              <el-option label="下单未支付" value="下单未支付"> </el-option>
              <el-option label="王文政垫付" value="王文政垫付"> </el-option>
              <el-option label="汲生鑫垫付" value="汲生鑫垫付"> </el-option>
              <el-option label="任天宇垫付" value="任天宇垫付"> </el-option>
              <el-option label="修振垫付" value="修振垫付"> </el-option>
              <el-option label="董明垫付" value="董明垫付"> </el-option>
              <el-option label="公账支付" value="公账支付"> </el-option>
              <el-option label="账期结算" value="账期结算"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="结算方式">
            <el-select
              v-model="formInline.settlementState"
              @change="queryClick"
              style="width: 120px"
              placeholder="结算方式"
            >
              <el-option label="全部" value=""> </el-option>
              <el-option label="未结算" value="未结算"> </el-option>
              <el-option label="已结算" value="已结算"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template slot="row-info" slot-scope="scope">
        <warehouse-purchase-info :purchaseInfo="scope.row" />
      </template>
    </x-table>
  </div>
</template>

<script>
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";
import warehousePurchaseInfo from "@/components/business/warehousePurchaseInfo.vue";
import purchaseDetailPage from "./__arranged_purchase_detail.vue";
import purchaseFromPage from "./__arranged_purchase_form.vue";

export default {
  components: {
    customerStoreSelect,
    warehousePurchaseInfo,
  },
  props: {
    tabName: {
      type: String,
    },
    hiddenStore: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return Object.assign(
        {},
        this.pageQuery,
        this.hiddenStore ? {} : { storeGuid: this.storeGuid },
        this.queryModel || {}
      );
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  methods: {
    refresh() {
      if (this.$refs.list) {
        this.$refs.list.refresh();
      }
      this.$emit("call-event", "refresh");
    },
    clearClick() {
      this.formInline = {
        paymentAccount: "",
        settlementState: "",
      };
      this.queryModel = {};
    },
    queryClick() {
      this.queryModel = Object.assign({}, this.formInline);
    },
  },
  data() {
    return {
      storeGuid: "",
      queryModel: {},
      formInline: {
        paymentAccount: "",
        settlementState: "",
      },
      paramList: [
        {
          label: "状态",
          type: "select",
          field: ["optStatus"],
          styleValue: "width: 160px",
          options: [
            {
              label: "全部",
              value: "",
            },
            {
              label: "等待入库",
              value: "0",
            },
            {
              label: "部分入库",
              value: "1",
            },
            {
              label: "全部入库",
              value: "2",
            },
            {
              label: "已关闭的",
              value: "3",
            },
          ],
          default: "",
        },
        {
          label: "采购单号/计划单号/采购单备注信息查询",
          field: ["queryValue"],
          styleValue: "width: 320px",
        },
      ],
      fieldList: [
        {
          label: "记录信息",
          minWidth: "280",
          slot: "info",
        },
      ],
      actionList: [
        {
          label: "详情",
          linkType: "primary",
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: "采购单记录详情",
              refresh: this.refresh,
              component: purchaseDetailPage,
              params: {
                guid: row.guid,
                storeGuid: row.storeGuid,
              },
            });
          },
        },
        {
          label: "编辑",
          linkType: "primary",
          show: (row) => {
            return row.optStatus != 3;
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: "编辑采购单信息",
              refresh: this.refresh,
              component: purchaseFromPage,
              params: {
                guid: row.guid,
                storeGuid: row.storeGuid,
              },
            });
          },
        },
        {
          label: "关闭",
          linkType: "danger",
          disabled: (row) => {
            return row.inboundGoodsCount > 0 || row.optStatus == 3;
          },
          click: (row, tag, refresh) => {
            this.$confirm("确认关闭采购单？", "警告", {
              type: "error",
            }).then(() => {
              this.cancelLoading = true;
              this.requestApi(
                "biz.warehouse.purchase.info.close",
                {
                  guid: row.guid,
                  storeGuid: row.storeGuid,
                },
                {
                  showError: true,
                }
              ).then(() => {
                this.refresh();
              });
            });
          },
        },
      ],
    };
  },
};
</script>
